import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Form extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
    className: PropTypes.string,
    autoComplete: PropTypes.oneOf(['on', 'off']),
    onSubmit: PropTypes.func,
    name: PropTypes.string,
  }

  static defaultProps = {
    autoComplete: 'on',
  }

  onSubmit = (event) => {
    event.preventDefault()
    this.props.onSubmit()
  }

  render() {
    const { className, autoComplete, children, name } = this.props

    return (
      <form noValidate name={name} autoComplete={autoComplete} onSubmit={this.onSubmit} className={className}>
        {children}
      </form>
    )
  }
}

export default Form



// WEBPACK FOOTER //
// ./src/components/Common/Form.js